import accessories from './accessories'
import activities from './activities'
import addresses from './addresses'
import agreements from './agreements'
import backends from './backends'
import billingstatuses from './billingstatuses'
import carriers from './carriers'
import categories from './categories'
import companies from './companies'
import companystates from './companystates'
import contacts from './contacts'
import features from './features'
import globals from './globals'
import hardware from './hardware'
import industries from './industries'
import invoices from './invoices'
import mailchimp from './mailchimp'
import orders from './orders'
import organizations from './organizations'
import partners from './partners'
import partnertypes from './partnertypes'
import payments from './payments'
import paymentintervals from './paymentintervals'
import quickbooks from './quickbooks'
import quotes from './quotes'
import service from './service'
import shippingtypes from './shippingtypes'
import sources from './sources'
import tasks from './tasks'
import terms from './terms'
import updateintervals from './updateintervals'
import users from './users'
import vendors from './vendors'

const stores = {
  accessories,
  activities,
  addresses,
  agreements,
  backends,
  billingstatuses,
  carriers,
  categories,
  companies,
  companystates,
  contacts,
  features,
  globals,
  hardware,
  industries,
  invoices,
  mailchimp,
  orders,
  organizations,
  partners,
  partnertypes,
  payments,
  paymentintervals,
  quickbooks,
  quotes,
  service,
  shippingtypes,
  sources,
  tasks,
  terms,
  updateintervals,
  users,
  vendors
}

export default stores



// WEBPACK FOOTER //
// ./src/stores/index.js